import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpSimCard } from "../models/core"
import { ColumnInfo, OpHistory } from "../models/custom"


export class DataProviderSimCard {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getSimCardFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpSimCard>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdSimCard, 'OpxSimCardFilter', 'OpxSimCardFilterResult')
    }

    public getSimCard = (id: number): JQueryPromise<OpSimCard> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetSimCard', { IdSimCard: id }, 'OpxGetSimCardResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpSimCard = new OpSimCard(response)

                    return OpSimCard
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((simCards: OpSimCard[]) => _.first(simCards))
                }

                return null
            })
    }

    public getSimCardHistory = (id: number): JQueryPromise<OpHistory[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetSimCardHistory', { IdSimCard: id }, 'OpxGetSimCardHistoryResult')
            .then(data => {
                var result: OpHistory[] = DataProvider.convertArrayResult<OpHistory>(data, OpHistory)
                return result
            })
    }

    public saveSimCard = (opObj: OpSimCard): JQueryPromise<OpSimCard> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveSimCard', { ToBeSaved: opObj.toJSON() }, 'OpxSaveSimCardResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpSimCard = new OpSimCard(response)

                    return OpSimCard
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((simCards: OpSimCard[]) => _.first(simCards))
                }

                return null
            })
    }

    public deleteSimCard = (opObj: OpSimCard): JQueryPromise<OpSimCard> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteSimCard', { ToBeDeleted: opObj.toJSON() }, null)
    }

    // Public Methods End
}

